import { render, staticRenderFns } from "./template-work-order-tasks.html?vue&type=template&id=536631fa&scoped=true&"
import script from "./template-work-order-tasks.js?vue&type=script&lang=js&"
export * from "./template-work-order-tasks.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536631fa",
  null
  
)

export default component.exports